import 'suggestions-jquery'

$(function() {
    $("#full_address").suggestions({
        token: "48c365d8357d6e2c17e1c3c9ce1f94e52126c957",
        // token: $(this).data('token'),
        type: "ADDRESS",
        /* Вызывается, когда пользователь выбирает одну из подсказок */
        onSelect: function (suggestion) {
            $('#postal_code').val(suggestion.data.postal_code)
            $('#region').val(suggestion.data.region_with_type)
            $("#country").val(suggestion.data.country)
            $("#country_code").val(suggestion.data.country_iso_code)
            $("#kladr_id").val(suggestion.data.kladr_id)

            if (suggestion.data.city_with_type) {
                $('#city').val(suggestion.data.city_with_type)
            } else {
                $("#city").val(suggestion.data.settlement_with_type)
            }
            $('#street').val(suggestion.data.street_with_type)
            $('#area').val(suggestion.data.area_with_type)


            let segments = []
            if (suggestion.data.house_type && suggestion.data.house) {
                segments.push(`${suggestion.data.house_type} ${suggestion.data.house}`)
            }
            if (suggestion.data.block_type && suggestion.data.block) {
                segments.push(`${suggestion.data.block_type} ${suggestion.data.block}`)
            }

            $('#house').val(segments.join(' '))
            $('#flat').val(suggestion.data.flat)
        }
    });
})